import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppFeatureExtensions, JobFilterExtensions } from '@app/app-feature-extensions.config';
import { LayoutConfig, LayoutPrivileges, } from '@app/layout/layout.abstract.config';
import { GlobalSearchResults } from '@shared/models';


@Component({
  selector: 'mojo-global-search-results',
  templateUrl: './global-search-results.component.html',
  styleUrls: ['./global-search-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSearchResultsComponent {
  @Input('results')
  set setResults(value: GlobalSearchResults) {
    this.searchedResults = value;
    this.showResults = this.checkIfAnyResultIsFound(value);
  }
  @Input() searchedPhrase: string;

  @Output() searchPageEvent = new EventEmitter<string>();

  searchedResults: GlobalSearchResults;
  showResults: boolean;
  privileges: LayoutPrivileges;
  jobStatusFilterFeature$: Observable<JobFilterExtensions> =
    this.featureExtensionsService.licenseFeatureExtensions$
      .pipe(
        map((extensions) => extensions.includes(AppFeatureExtensions.JOB_STATUSES_BASIC)
          ? AppFeatureExtensions.JOB_STATUSES_BASIC
          : AppFeatureExtensions.JOB_STATUSES_ALL
        )
      );

  constructor(
    private featureExtensionsService: MojoFeatureExtensionsService,
    private layoutConfig: LayoutConfig,
    private router: Router,
  ) {
    this.privileges = this.layoutConfig.privileges;
  }

  checkIfAnyResultIsFound(results: GlobalSearchResults): boolean {
    let hasNonEmptyArray = false;
    Object.keys(results).forEach((key) => {
      if (results[key].length > 0) {
        hasNonEmptyArray = true;
      }
    });
    return hasNonEmptyArray;
  }

  goToSearchPage(searchPhrase) {
    this.searchPageEvent.emit(searchPhrase);
    setTimeout(() => {
      this.router.navigate(['jobs/search'], { queryParams: { searchPhrase } });
    }, 0);
  }
}
